import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import './Style.scss'

const TextAboveImage = ({ articleObj }) => {
    var content = articleObj;

    const handleErrorImageLoading=({currentTarget}) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src=content.attributes.fallbackImageUrl?content.attributes.fallbackImageUrl:"";
      }

    return (
        <>
            <div className={`${content.attributes.articleRendering} ${content.attributes.class}`} data-type="TextAboveImage">
                <div className='card-design'>
                {content.title ?
                    <p className='card-text' dangerouslySetInnerHTML={{ __html: content.title }}></p>
                :""}
                 {content.body ?
                    <div className='card-body' dangerouslySetInnerHTML={{ __html: content.body }}></div>
                :""}
                    {content.attributes.mainImageUrl ? 
                    <Link target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""} 
                        to={content.attributes.mainImageUrl}>  
                        <img src={`${content.mainImage ? content.mainImage : ""}`} onError={handleErrorImageLoading} fetchpriority="high" className='img-fluid' alt={content.attributes.altText} />
                    </Link>
                        : 
                        <img src={`${content.mainImage ? content.mainImage : ""}`} className={`img-fluid ${content.attributes.imageRendering}`} fetchpriority="high" alt={content.attributes.altText} />
                }
                </div>
            </div>
        </>
    )
}

export default TextAboveImage